export const datePickerConfig = {
  start: "2019-01-01"
}